import type { Nullable } from 'corgi-types';
import type { ContentFullContentImageSet, ContentImageSet } from 'graphql-ts-types';

export const createLazyLoadingAttribute = (isLazy = false) => {
  if (!isLazy) {
    return null;
  }

  return { loading: 'lazy' as const };
};

export const getActiveSlideProps = (isActive: boolean) => {
  if (!isActive) {
    return null;
  }

  return { 'data-active-slide': true };
};

const getImageUrls = (contentImage: Nullable<ContentImageSet>) => ({
  x1: contentImage?.x1?.url ?? '',
  x2: contentImage?.x2?.url ?? '',
  x3: contentImage?.x3?.url ?? '',
});

export const transformToPrismicImage = (image: ContentFullContentImageSet) => ({
  mobile: getImageUrls(image.forMobile),
  tablet: getImageUrls(image.forTablet),
  desktop: getImageUrls(image.forDesktop),
  large_desktop: getImageUrls(image.forLargeDesktop),
});
